import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { isMockApiEnabled } from './mocks/env';
import './theme/fonts.css';

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root non trovato in index.html');

/**
 * The mock backend must be installed before the first render, otherwise the
 * session-rehydration query would fire against the real axios adapter. The
 * dynamic import keeps the fixtures out of a production bundle.
 */
async function bootstrap(root: HTMLElement): Promise<void> {
  if (isMockApiEnabled()) {
    const { installMockBackend } = await import('./mocks');
    installMockBackend();
  }

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap(container);
